import { TeachingHallHistory } from '../../lib/types/models/ol/teaching-hall/teaching-hall-history'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export async function getTeachingHallAssignments(input: { olId: number; teachingHallId: number }) {
  return restApiClient
    .url(
      constructApiUrl(API.ols.getTeachingHallHistoryOfAssignments.url, {
        olId: input.olId,
        id: input.teachingHallId
      })
    )
    .get<TeachingHallHistory[]>()
}
